import * as Constants from "../../consts/Constants";

class Redirection {
  constructor() {
    this.indexMap = new Map();
    this.indexMap.set(Constants.ROLE_ADMIN_ID, Constants.ROUTE_BUSINESS);
    this.indexMap.set(Constants.ROLE_PRESS_ADMIN_ID, Constants.ROUTE_NEWS);
    this.indexMap.set(
      Constants.ROLE_POLICE_ADMIN_ID,
      Constants.ROUTE_EMERGENCY
    );
    this.indexMap.set(Constants.ROLE_HEALTH_ADMIN_ID, Constants.ROUTE_COVID);
    this.indexMap.set(Constants.ROLE_CALLS_ADMIN_ID, Constants.ROUTE_CALLS_ADMIN);
  }

  getIndexByRoles(roles) {
    for (let i = 0; i < roles.length; i++) {
      if (this.indexMap.get(roles[i]) !== undefined) {
        return this.indexMap.get(roles[i]);
      }
    }
    return Constants.ROUTE_NEWS;
  }
  
}

export default new Redirection();
